import React, { useContext, useEffect, useRef, useState } from 'react'
import Loader from '~/prix/react/components/loader'
import { fromUnknownError } from '~/prix'
import mapboxgl from 'mapbox-gl'
import publicConfig from '~/utils/client/publicConfig'
import { MapContext } from './mapContext'
import { LatLngBoundsLiteral, LatLngLiteral, WeightedLocation } from '../map/mapPosition'
import { MapType } from '../map/mapContext'
import { colorMaps } from '~/design'
import GoogleHeatmap from '../googleMap/heatmap'
import MapboxHeatmap from '../mapbox/heatmap'

interface HeatmapProps {
  positions: WeightedLocation[]
  opacity?: number
  radius?: number
  gradient?: string[]
  resolution?: number
}

export default function Heatmap({
  positions,
  opacity,
  radius,
  gradient = colorMaps.toHeatHeatmap,
  resolution = 8,
}: HeatmapProps) {
  const mapContext = useContext(MapContext)
  if (!mapContext) {
    throw new Error('Heatmap must be used within a map')
  }

  const { mapProvider } = mapContext

  let layerJSXElement: JSX.Element
  if (mapProvider === 'google') {
    layerJSXElement = (
      <GoogleHeatmap
        positions={positions}
        gradient={gradient}
        resolution={resolution}
        opacity={opacity}
        radius={radius}
      />
    )
  } else if (mapProvider === 'mapbox') {
    layerJSXElement = (
      <MapboxHeatmap
        positions={positions}
        gradient={gradient}
        resolution={resolution}
        opacity={opacity}
        radius={radius}
      />
    )
  } else {
    throw new Error(`Unsupported map provider: ${mapProvider}`)
  }

  return layerJSXElement
}
